import Image from "next/image";
import { FC } from "react";

type Props = {};

const EmailBlockPrivacy: FC<Props> = () => {
	return (
		<div className='flex flex-col items-center'>
			<p className='text-[50px] font-bold mt-[98px] max-desktop:mt-[59px] max-desktop:text-[28px]'>
				HOW TO CONTACT US?
			</p>

			<p className='text-[23px] w-[821px] max-desktop:w-[580px] max-desktop:text-[17px] font-[500] max-tablet:w-full mt-[15px] text-center tracking-[1px]'>
				World Bridge Holding CY Limited is the controller for the processing of
				your personal data. Our contact information is:
				<br />
				<br />
				Address: 195 Arch. Makarios III Avenue, Neocleous, House 3030,
				Limassol, Cyprus
			</p>
			<div className='border-[2px] border-white w-[821px]  mx-auto mt-[80px] max-desktop:mt-[45px] flex flex-col items-center py-[45px] max-desktop:py-[32px] rounded-[15px] max-desktop:w-[580px] max-tablet:w-full'>
				<Image
					width={53}
					height={42}
					src={"/icons/mail.svg"}
					alt='Mail Icon'
					className='max-desktop:w-[33px] max-desktop:h-[23px]'
				/>
				<p className='text-center font-bold text-[27px] mt-[31px] max-desktop:mt-[20px] max-desktop:text-[18px]'>
					info@wbtbridge.com
				</p>
				<p className='text-center opacity-85 text-[27px] font-[400] mt-[15px]  max-desktop:mt-[4px] max-desktop:text-[18px] max-desktop:leading-[20px] px-[60px] tracking-[1px]'>
					If you have any questions concerning the processing of your personal
					data, or your privacy, please e-mail us, and we will do our best to
					resolve the issue as soon as possible.
				</p>
			</div>
		</div>
	);
};

export default EmailBlockPrivacy;
